import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section
      className="rk-section"
      style={{ paddingTop: "calc(var(--rk-section-py) + 60px)" }}
    >
      <div className="rk-container-text">
        <div className="rk-eyebrow">404</div>
        <h1 className="rk-heading-page mt-5">Not found.</h1>
        <p className="mt-7 rk-body" style={{ color: "var(--rk-muted)" }}>
          The page you are looking for does not exist.
        </p>
        <div className="mt-10">
          <Link to="/" className="rk-btn-primary">
            Return home
          </Link>
        </div>
      </div>
    </section>
  );
}
